import React from 'react'
import BikeListingReviews from './BikeListingReviews.js'
import { Columns, Header } from 'components/elements/index.js'
import PaginateArray from '../../elements/paginateArray'

const BikeListingReviewWrap = ({
  reviews,
  reviewCount,
  bikeOwnerRating,
  reviewOverallRating,
  bikeId,
  isMobile,
  bikeData,
}) => {
  return (
    <Columns>
      <Columns.Column size={12}>
        {reviews.length > 0 && (
          <>
            <div>
              <Header
                renderas="h2"
                size={5}
                className="has-text-weight-extra-bold mb-6 review-block-title"
              >
                <div className='is-flex is-align-items-center'>
                  <span className="mr-1">{'Reviews & Ratings'}</span>
                    <i class="fa-solid fa-star ml-2"></i>
                </div>
                {/* {reviewOverallRating > 0 &&
              <RatingStars
                className="bike-profile-review-block" 
                rating={reviewOverallRating} 
                size="large" 
                showInfo={false} 
              />} */}
              </Header>
              <div className="bike-owner-renter-wrapper mb-4">
                <div className="mb-4 bike-renter">
                  <div className="bike-renter-wrap">
                    <i className="fas fa-motorcycle fa-2x"></i>
                    <div className="review-header-container">
                      <Header renderas="h3" size={7} className="mb-0">
                        Bike
                      </Header>
                      {reviewOverallRating && (
                        <p className="renter-bike-rating">
                          {reviewOverallRating + ' '}
                          <i className="fa fa-star bike-profile-bike-rating"></i>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div className="mb-4 bike-owner">
                  <div className="bike-owner-wrap">
                    <i className="fas fa-user fa-2x"></i>
                    <div className="owner-header-container">
                      <Header renderas="h3" size={7} className="mb-0">
                        Owner
                      </Header>
                      {bikeOwnerRating && (
                        <p className="owner-bike-rating">
                          {bikeOwnerRating + ' '}
                          <i className="fa fa-star bike-profile-bike-rating"></i>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <PaginateArray
              data={reviews}
              buttonText="More Reviews"
              pageLimit={reviewCount}
              bikeId={bikeId}
              render={({ item: review, index }) => (
                <BikeListingReviews
                  reviews={reviews}
                  key={index}
                  reviewAvatar={review.guest_review_avatar_cloudinary_public_id}
                  reviewUserID={review.guest_id}
                  reviewDate={review.guest_review_date}
                  reviewName={review.guest_review_name}
                  //reviewBikeTitle={review.guest_review_bike_title}
                  reviewBikeMake={review.guest_review_make}
                  reviewBikeModel={review.guest_review_model}
                  reviewBikeID={review.guest_review_bike_id}
                  reviewYear={review.guest_review_bike_year}
                  reviewRating={review.guest_review_rating}
                  reviewBikeBody={review.guest_bike_review_text}
                  review={review}
                  reviewOwnerBody={review.guest_owner_review_text}
                  //reviewLocation={review.location}
                  reviewMotoLocation={review.motorcycle_location}
                  reviewUserLocation={review.guest_location}
                  reviewMotoActive={review.motorcycle_active}
                  reviewAuthorActive={review.rider_active}
                  showMotorcycleLink={false}
                  motorcycleRating={review.motorcycle_rating}
                  ownerRating={review.owner_rating}
                  isMobile={isMobile}
                />
              )}
            />
          </>
        )}

        {reviews.length === 0 && (
          <div className="no-reviews-bike-profile-wrap">
            <Header
              renderas="h2"
              size={5}
              className="has-text-weight-extra-bold mb-3"
            >
              Guest Reviews
            </Header>
            <p>No Reviews Yet.</p>
          </div>
        )}
      </Columns.Column>
    </Columns>
  )
}

export default BikeListingReviewWrap
